const serverEnvironment = process.env.REACT_APP_SERVER_ENV || "dev";

const protocol = process.env.REACT_APP_SERVER_NETWORK_PROTOCOL || "http";

const serverAddress = process.env.REACT_APP_SERVER_ADDRESS || "localhost:4000";

const serverUrl = process.env.REACT_APP_SERVER_URL || protocol + "://" + serverAddress;

const playGameWithCodeURL =
  process.env.PLAY_GAME_URL || serverEnvironment === "production" ? "played.com.au" : "playedu.webflow.io/play";

const googleAnalyticsTrackingId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || "UA-191404734-2";
const googleTagManagerId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || "GTM-5KVNV4G";
const stripePublicKey =
  process.env.REACT_APP_STRIPE_PUB_KEY ||
  "pk_test_51JeYcLLgRg1mnvJ79fTrhZQxHh3qxYEZFveSzfjvtI7pvuqmqr9cXomSfH6xRrUL49TmONWH2toevmMUwpAfY2yq005DHyTRLn";

export {
  serverEnvironment,
  serverUrl,
  protocol,
  playGameWithCodeURL,
  googleAnalyticsTrackingId,
  googleTagManagerId,
  stripePublicKey,
};
